import YoutubeEmbedVideo from '../youtube-embed-video/youtube-embed-video';
import React from 'react';
import { WPBlockProps } from './types';
import { consentContext } from '../../context/ConsentContext';

function WpYoutubeVideo({ block }: WPBlockProps): JSX.Element | null {
  const url = block?.attributes?.url;

  if (!url) return null;
  const divStyle = {
    display: 'flex',
    'justify-content': 'flex-end',
    width: '100%',
  };
  const style = { width: '59%', margin: '0 121px 40px 0' };
  return (
    <consentContext.Consumer>
      {(context: any) => (
        <div style={divStyle}>
          {context.cookieConsent && (
            <YoutubeEmbedVideo
              videoUrl={url}
              enhancedPrivacy={true}
              suggestions={false}
              width={640}
              height={360}
              style={style}
              controls={true}
            />
          )}
        </div>
      )}
    </consentContext.Consumer>
  );
}

export default WpYoutubeVideo;
